<template>
  <div class="sub_content col-12 mt-2">
    <ValidationObserver ref="observer" v-slot="{ passes }">
      <b-form @submit.prevent="passes(onSubmit);" @reset="resetForm">
        <div class="row">
          <DataListWithValidation
            rules="required"
            type="text"
            label="회사명"
            name="form.company1.name"
            size="sm"
            class="col-6 d-inline-block"
            v-model="form.company1.name"
            :options="companyOption1"
            @dataChanged="dataChanged1"
            description=""
            placeholder="회사를 입력해주세요."
          />

          <SelectWithValidation
            rules="required"
            type="text"
            label="지점명"
            name="form.company2.name"
            size="sm"
            class="col-6 d-inline-block"
            v-model="form.company2.seq"
            :options="companyOption2"
            @dataChanged="dataChanged2"
            description=""
            placeholder="지점를 입력해주세요."
          />
        </div>

        <div class="row">
          <InputWithValidation
            rules="required|min:2"
            type="text"
            label="이름"
            title="이름"
            name="form.name"
            size="sm"
            class="col-6 d-inline-block"
            v-model="form.name"
            description=""
            placeholder="이름을 입력해주세요."
          />
          <InputWithValidation
            rules="required|min:6"
            type="text"
            label="연락처"
            title="연락처"
            name="form.tel"
            size="sm"
            class="col-6 d-inline-block"
            v-model="form.tel"
            description=""
            placeholder="연락처를 입력해주세요."
          />
        </div>
        <hr/>
        <div class="float-right">
          <b-button type="reset" size="sm" variant="danger" class="mr-2">다시쓰기</b-button>
          <b-button type="submit" size="sm" variant="primary" class="mr-2">저장</b-button>
          <b-button type="button" size="sm" variant="dark" v-on:click="cancel">취소</b-button>
        </div>
      </b-form>
    </ValidationObserver>
  </div>
</template>

<script>
import _ from 'lodash'
import { ValidationObserver } from 'vee-validate'
import InputWithValidation from '@/components/common/validations/inputbox'
import DataListWithValidation from '@/components/common/validations/datalist'
import SelectWithValidation from '@/components/common/validations/selectbox'
import { phoneNumber } from '@/mixin/phoneNumber'
import ax from '@/api/user'
import { mCompanys, sCompanys } from '@/api/company'

export default {
  name: 'UserView',
  components: {
    ValidationObserver,
    InputWithValidation,
    DataListWithValidation,
    SelectWithValidation
  },
  mixins: [phoneNumber],
  data () {
    return {
      companyOption1: [
        { value: '', text: '선택' },
      ],
      companyOption2: [
        { value: '', text: '선택' }
      ],
      form_: {
        tel: '',
        name: '',
        company1: {
          seq: null,
          name: '',
          sname: ''
        },
        company2: {
          seq: null,
          name: '',
          sname: ''
        }
      },
      form: {}
    }
  },
  watch: {
    'form.tel': function () {
      this.form.tel = this.phoneNumberMask(this.form.tel)
    }
  },
  created () {
    this.form = _.cloneDeep(this.form_)
  },
  mounted () {
    mCompanys(response => {
      this.companyOption1 = response
    })
    if (this.$route.params.seq) {
      ax.get(this.$route.params.seq, response => {
        this.form = response
      })
    }
  },
  methods: {
    onSubmit () {
      ax.save(this.$route.params.seq || null, this.form, (code, msg) => {
        this.$notify({
          group: 'alert',
          type: 'info',
          title: '정보',
          text: msg
        })
        if (code === 200) {
          this.$router.push({ path: '/user', query: this.$route.query })
        }
      })
    },
    resetForm () {
      this.form = _.cloneDeep(this.form_)
      requestAnimationFrame(() => {
        this.$refs.observer.reset()
      })
    },
    cancel () {
      this.$router.push({ path: '/user', query: this.$route.query })
    },
    dataChanged1 (v) {
      // console.log('dataChanged1', v)
      if (v.value !== '') {
        sCompanys(v.text, response => {
          this.companyOption2 = [{ value: '', text: '선택' }, ...response]
        })
      } else {
        this.companyOption2 = [{ value: '', text: '선택' }]
      }
    },
    dataChanged2 (v) {
      // console.log('dataChanged2', v)
      this.form.csseq = v
    }
  }
}
</script>

<style lang="scss" scoped>

.sub_content {
}


</style>
